<template>
  <div class="card" v-if="infoCommande">
    <header class="header-card">
      <p>{{ $t('detailOrdreTravailTech.caracterique.infoCommande.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoCommande.code')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              <router-link-blank v-if="infoCommande.devisCommandeId"
                :to="{ name: 'c.bodac.commandes',
                 params: { id: infoCommande.devisCommandeId }}"
                class="lien"
                :message="infoCommande.devisCommande.code">
              </router-link-blank>
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoCommande.dateCampagne')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ infoCommande.devisCommande.datePremierAffichage | formatDate }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoCommande.codeDossier')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ infoCommande.devisCommande.codeDossier }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoCommande.theme')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ infoCommande.devisCommande.theme }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoCommande.etat')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ $t(infoCommande.etatLibelle) }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('detailOrdreTravailTech.caracterique.infoCommande.commercial')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ infoCommande.nomCommercial }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import getAll from '@/api/ligneCommandeRecherche';
import { DEVIS_COMMANDE_ETAT, TYPE_COMMANDE, SENS_VENTE } from '@/configuration/devisConf';
import transformer from '@/services/ligneCommande/ligneCommandeRechercheServerTableDataTransformer';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      infoCommande: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
  },
  methods: {
    async getInfoCommande() {
      const dataQuery = {
        query: {
          societeId: this.societeActiveId,
          typesDevisCommandeFacture: [TYPE_COMMANDE],
          agencesId: this.agencesSelectionnees.map(agence => agence.agenceId),
          ids: this.ordreTravail.affectationsTechniquesLignesCommandeIds,
          sens: SENS_VENTE,
        },
      };
      const dataToSend = transformer(cloneDeep(dataQuery));
      const data = (await getAll(dataToSend)).data.result;
      data.items.forEach((ligne) => {
        if (ligne.devisCommande.commercial) {
          ligne.nomCommercial = nomPrenomGetter(ligne.devisCommande.commercial);
        }
        const etat = DEVIS_COMMANDE_ETAT.find((etatInList) => {
          return etatInList.code === ligne.devisCommande.etat;
        });
        ligne.etatLibelle = etat ? etat.libelle : '';
      });
      this.infoCommande = data.items[0];
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.getInfoCommande();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style>

</style>
